import { capitalize } from 'lodash';
import { numberWithCommas, titleCase } from '../../../../../utils/helpers';

const UsersSectionTable = ({ users, onSort, sortColumn }) => {
	const headers = [
		{ label: 'No', path: 'no', key: 'no' },
		{ label: 'ID', key: 'id' },
		{ label: 'Email', key: 'email' },
		{ label: 'Card', key: 'card' },
		{ label: 'Class', key: 'class' },
		{ label: 'Rank', path: 'balance', key: 'rank' },
		{ label: 'MMP Value', path: 'currentPackageValue', key: 'value' },
		{ label: 'MMI', path: 'mmiStartAmount', key: 'value' },
		{ label: 'Position', key: 'position' },
		{ label: 'Level', path: 'level', key: 'level' },
	];

	const getSortIcon = (column) => {
		if (!column.path) return null;
		if (column.path !== sortColumn.path)
			return (
				<div className='d-flex flex-column'>
					<i className='text-my-success fas fa-sort-up opacity-25'></i>
					<i className='text-my-danger fas fa-sort-down opacity-25' />
				</div>
			);
		if (sortColumn.order === 'asc')
			return (
				<div className='d-flex flex-column'>
					<i className='text-my-success fas fa-sort-up'></i>
					<i className='text-my-danger fas fa-sort-down opacity-0' />
				</div>
			);
		return (
			<div className='d-flex flex-column'>
				<i className='text-my-success fas fa-sort-up opacity-0'></i>
				<i className='text-my-danger fas fa-sort-down' />
			</div>
		);
	};

	return (
		<>
			<div className='centerAll mb-1 text-set3'>
				<i className='fas fa-users me-2'></i>
				<div className='fs-4 text-center'>My Downlines</div>
			</div>
			<div className='table-responsive'>
				<table className='table table-sm myDownlinesTable text-center'>
					<thead>
						<tr>
							{headers.map((h, key) => (
								<th
									key={key}
									className={`col-${h.key}`}
									onClick={() => onSort(h.path)}
									style={h.path ? { cursor: 'pointer' } : {}}>
									<div className='d-flex justify-content-center align-items-center text-set3'>
										<div className='me-1'>{h.label}</div> {getSortIcon(h)}
									</div>
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{users.map((user, key) => (
							<tr key={key}>
								<td className='col-no'>{user.no}</td>
								<td className='col-id'>{user.id}</td>
								<td className='col-email'>{user.email}</td>
								<td className='col-card'>{capitalize(user.card)}</td>
								<td className='col-class'>{capitalize(user.userClass)}</td>
								<td className='col-rank'>{titleCase(user.userRank)}</td>
								<td className='col-value'>
									{user.active
										? `$${numberWithCommas(user.currentPackageValue / 1e6)}`
										: 'Inactive'}
								</td>
								<td className='col-value'>
									{user.mmiStartAmount
										? `$${numberWithCommas(user.mmiStartAmount / 1e6)}`
										: 'Inactive'}
								</td>
								<td className='col-position'>{user.position}</td>
								<td className='col-level'>{user.level}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default UsersSectionTable;
